import { PlusCircleOutlined } from '@ant-design/icons'
import { MobilePartner, usePartners } from '@entities/partner'
import { AdPostingMobileHeader } from '@widgets/ad-posting-mobile-header'
import { BottomNavMobile } from '@widgets/page-template/ui/bottom-nav-mobile'
import { Button, Col, Row, theme, Typography } from 'antd'
import { useNavigate } from 'react-router'

const { Text } = Typography

export const PartnersPage = () => {
    const {
        token: { colorBgContainer, colorPrimary }
    } = theme.useToken()

    const {
        partners,
        isPartnersLoading,
        actions: { deletePartner }
    } = usePartners()

    const navigate = useNavigate()

    return (
        <>
            <AdPostingMobileHeader
                current="partners"
                title="Партнеры"
                filter={
                    <Button type="text" onClick={() => navigate('new')}>
                        <PlusCircleOutlined style={{ fontSize: 23, color: colorPrimary }} />
                    </Button>
                }
            />
            <div
                style={{
                    position: 'relative',
                    background: colorBgContainer,
                    padding: '20px 16px',
                    overflow: 'auto',
                    flexGrow: 1
                }}
            >
                {partners?.length ? (
                    <Row justify={'end'} gutter={[0, 25]}>
                        {partners.map((p) => (
                            <Col span={24} key={p.id}>
                                <MobilePartner partner={p} onDelete={() => deletePartner({ id: p.id })} />
                            </Col>
                        ))}
                    </Row>
                ) : (
                    <Row justify={'end'}>
                        <Col span={24}>
                            <Text>У вас пока нет партнеров</Text>
                        </Col>
                    </Row>
                )}
            </div>
            <BottomNavMobile />
        </>
    )
}
